/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { Text } from "components/text";
/**
 * Internal dependencies
 */

const ReportHeader = ({ name, actions, children }) => {
  return (
    <Box className="dashboard-report__header flex space-between center align-center relative mb-6">
      <Text decoration="dotted" variant="headingXs">
        {name}
      </Text>
      {children}
    </Box>
  );
};

export default ReportHeader;
